import { Account } from "./account";
import { Horse } from "./horse";
import { Livestock } from "./livestock";
import { Photo } from "./photo";
import { PointStats } from "./point-stats";
import { RodeoEventSchedule } from "./rodeoEventSchedule";
import { Video } from "./video";

export class RodeoEventRun {
    id: number;
    round: number;
    rotation: number;
    runIdentifier: string;
    extraLabel: string;
    number: number = 0;
    turnedOut: boolean;
    tradeBlocked: boolean;
    tradePending: boolean;
    hideTrade: boolean;

    scheduleName: string;
    scheduledDate: string;
    rodeoEventSchedule: RodeoEventSchedule;
    rodeoEventScheduleId: number;

    contestantOne: Account;
    contestantOneId: number;
    contestantOneHandicap: number;
    contestantTwo: Account;
    contestantTwoId: number;
    contestantTwoHandicap: number;

    horseOne: Horse;
    horseOneId: number;
    horseTwo: Horse;
    horseTwoId: number;

    livestock: Livestock;
    livestockId: number;
    loadOrder: number;

    displaySuccessfulRuns: any;

    isExtraRunForContestantOne: boolean;
    isExtraRunForContestantTwo: boolean;

    fromProgressionSourceId: number;

    payRiderOne: boolean;
    payRiderTwo: boolean;

    // TeamRoping
    noTime: boolean;
    timeDisplayValue: any;
    displayValue: any;

    oneLeg: boolean;
    barrierOneBreak: boolean;
    barrierTwoBreak: boolean;
    crossfire: boolean;
    
    knockdownBarrelOne: boolean;
    knockdownBarrelTwo: boolean;
    knockdownBarrelThree: boolean;
    
    straightOneSplit: number;
    straightTwoSplit: number;
    straightThreeSplit: number;
    straightFourSplit: number;

    aroundBarrelOneSplit: number;
    aroundBarrelTwoSplit: number;
    aroundBarrelThreeSplit: number;

    headerMiss: boolean;
    heelerMiss: boolean;
    disqualified: boolean;
    inReview: boolean;

    headerSplit: number;
    heelerSplit: number;
    
    markout: boolean;

    breakoutTime: number;
    
    // Timed Events
    startingTime: number = 0;
    penaltyTime: number = 0;
    time: any = 0;
    totalTime: number = 0;

    // Rough stock
    startingScore: number = 0;
    score: any = 0;
    totalScore: number = 0;

    updated: string;
    done: boolean;
    
    error: boolean;
    edited: boolean;
    editing: boolean;
    saving: boolean;

    displayFieldOne: string;
    displayFieldOneLabel: string;

    displayFieldTwo: string;
    displayFieldTwoLabel: string;

    displayFieldValue: any;

    isNominated: boolean;

    videos: Video[] = [];
    photos: Photo[] = [];
    points: PointStats[] | number | string = [];

    used: boolean;
}


// WEBPACK FOOTER //
// ./src/model/rodeoEventRun.ts